window.addEventListener('load', function () {
  const _learnq = window._learnq || [];
  let klAjax = true;

  function addedToCart(item = {}) {
    fetch(`${window.location.origin}/cart.js`)
      .then((res) => res.json())
      .then((data) => {
        const cart = {
          total_price: data.total_price / 100,
          $value: data.total_price / 100,
          total_discount: data.total_discount,
          original_total_price: data.original_total_price / 100,
          items: data.items,
          ...item,
        };

        if (klAjax) {
          _learnq.push(['track', 'Added to Cart', cart]);
          klAjax = false;
        }
      });
  }

  // Override fetch to detect add-to-cart events
  (function (ns, fetch) {
    ns.fetch = function (...args) {
      const response = fetch.apply(this, args);
      response.then((res) => {
        if (res.url.includes(`${window.location.origin}/cart/add.js`)) {
          addedToCart();
        }
      });
      return response;
    };
  })(window, window.fetch);

  // Event delegation for Add to Cart buttons
  document.body.addEventListener('click', function (event) {
    const button = event.target.closest("form[action*='/cart/add'] button[type='submit']");
    if (button && klAjax) {
      _learnq.push(['track', 'Added to Cart', {}]);
      klAjax = false;
    }
  });
});
